import SectionHeading from "components/text/SectionHeading";
import { IWooMetrics, IWooProduct } from "interfaces/IWoo.interface";
import { Table2, ChevronRight } from "lucide-react";

export default function WooCommerceProductsTable({
  woo,
}: {
  woo: IWooMetrics | null;
}) {
  return (
    <div className="mt-6 rounded-lg border bg-card p-4 shadow-sm">
      <SectionHeading
        title="Top Products"
        subtitle="Your best performing products"
      />
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Table2 className="h-4 w-4" /> Top products
        </div>
        <button className="inline-flex items-center gap-1 text-xs text-primary">
          View full report <ChevronRight className="h-3 w-3" />
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto text-sm">
          <thead className="text-left text-muted-foreground">
            <tr className="border-b">
              <th className="py-2 pr-4">SKU</th>
              <th className="py-2 pr-4">Product</th>
              <th className="py-2 pr-4">Sales</th>
            </tr>
          </thead>
          <tbody>
            {woo?.topProducts?.map((p: IWooProduct) => (
              <tr key={p.id} className="border-b last:border-0">
                <td className="py-2 pr-4 font-mono text-xs">{p.id}</td>
                <td className="py-2 pr-4">{p.name}</td>
                <td className="py-2 pr-4">{p.totalSales.toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
